
"use strict"; // jshint ignore:line

import { Vector3, Euler, Quaternion } from '../../src/js/three.module.js';

import { ObjectClickHandler } from './../utils/object-click-handler.js';
import { Painting }       from './classes/painting.js';
import { PaintingPlainFrame } from './classes/painting-frame.js';
import { DragHandle }     from './services/DragHandlesService.js'
import { WallService }    from "./services/WallsHandlerService.js";


/*
███████  █████  ██    ██ ██ ███    ██  ██████
██      ██   ██ ██    ██ ██ ████   ██ ██
███████ ███████ ██    ██ ██ ██ ██  ██ ██   ███
     ██ ██   ██  ██  ██  ██ ██  ██ ██ ██    ██
███████ ██   ██   ████   ██ ██   ████  ██████
*/
function saveLocally( old_arrangement ) {
	var saves       = getSaves();
	var arrangement = exportArrangement();

	if( old_arrangement ){
		if ( typeof old_arrangement == "string" ) old_arrangement = saves[old_arrangement];

		if ( !old_arrangement.created_at ) throw "Failed to save with old_arrangement. created_at missing";

		arrangement.created_at = old_arrangement.created_at;
	}

	saves[ arrangement.created_at ] = arrangement;
	window.available_arrangements[ arrangement.created_at ] = arrangement;

	arrangement.uid = arrangement.created_at;

	window.localStorage.setItem("model-preview.saves", JSON.stringify( saves ));

	console.info("Sommitelma tallennettu!", arrangement);

	return arrangement;
}
function getSaves() {
	var saves = JSON.parse(window.localStorage.getItem("model-preview.saves") || "{}");
	for( var uid in saves ){
		var save = saves[uid];
		save.uid = uid;

		save.list_uids = save.list_uids || [];

		if( save.list_uid && save.list_uids.indexOf(save.list_uid) == -1 ){
			save.list_uids.push( save.list_uid );
		}

		save.list_uids.sort(function(a, b){ return a.localeCompare(b); });

		save.$lists_hash = save.list_uids.join("-");
	}

	return saves;
}


function applyArrangement( arrangement ){
	if( arrangement == null || arrangement.version == null ) return;
	return applyArrangement["v"+arrangement.version].apply( null, arguments );
}

/*
██    ██ ██████
██    ██      ██
██    ██  █████
 ██  ██  ██
  ████   ███████
*/
function exportArrangement() {
	window.selected_lists = window.selected_lists || [];

	var created_at = Date.now();
	var arrangement = {
		uid        : created_at,
		created_at : created_at,
		updated_at : created_at,
		list_uids  : window.selected_lists.map(function(list){ return list.uid; }),
		version    : 2,
		oeuvres            : exportOeuvres(),
		player             : exportPlayer(),
		model              : exportModel(),
		walls              : exportWalls(),
		addit_objs         : exportAdditionalObjects()
	};

	arrangement.list_uids.sort(function(a, b){ return a.localeCompare(b); });
	arrangement.$lists_hash = arrangement.list_uids.join("-");

	arrangement.updated_at_str = (new Date(arrangement.updated_at)).toLocaleString();
	arrangement.title          = "Updated at "+ arrangement.updated_at_str;

	return arrangement;

	function exportOeuvres( ){
		var noeuvres = {};

		for (var uid in oeuvres) {
			var noeuvre = {
				pos          : oeuvres[uid].mesh.position.toArray(),
				qua          : oeuvres[uid].mesh.quaternion.toArray(),
				z_offset     : oeuvres[uid].z_offset || 0,
				visible      : !!oeuvres[uid].mesh.visible,
				disableEdges : !!oeuvres[uid].disableEdges,
				width        : oeuvres[uid].w,
				height       : oeuvres[uid].h,
				depth        : oeuvres[uid].d
			};

			extractComments( noeuvre, oeuvres[uid] );
			extractClickActs( noeuvre, oeuvres[uid] );

			oeuvres[uid].frameObj && (noeuvre.frame = {
				d  : oeuvres[uid].frameObj.d,
				rr : oeuvres[uid].frameObj.rr.top,
				m  : { color: "#"+oeuvres[uid].frameObj.material.color.getHexString() }
			});

			oeuvres[uid].canvasObj && (noeuvre.canvas = {
				d  : oeuvres[uid].canvasObj.d,
				rr : oeuvres[uid].canvasObj.rr.top,
				m  : { color: "#"+oeuvres[uid].canvasObj.material.color.getHexString() }
			});
			oeuvres[uid].availPlanes && (noeuvre.availPlanes = oeuvres[uid].availPlanes);

			if (noeuvre.pos.join("") != "000") noeuvres[uid] = noeuvre;
		}

		return noeuvres;
	}

	function exportPlayer(){
		return {
			av:  player.av,
			ah:  player.ah,
			pos: player.pos.toArray()
		};
	}

	function exportModel(){
		if( !$rootScope.model ) return {};
		var data = {
			config_key: $rootScope.model.config,
			format:     $rootScope.model.format
		};
		switch( data.format ){
			case "json_file":
				data.filename = $rootScope.model.file.name;
				data.size     = $rootScope.model.file.size;
				break;
			case "json_url":
				data.url = $rootScope.model.url;
				break;
		}
		return data;
	}

	function exportWalls(){
		var _walls = {};
		for (var uuid in window.wallService.walls) {
			var nwall = null, wall = window.wallService.walls[uuid];

			if (wall instanceof WallService.Wall && wall.oeuvresCount() > 0) {
				nwall = { t:0,
					pos:   wall.mesh.position.toArray(),
					qua:   wall.mesh.quaternion.toArray()
				};
			} else if (wall instanceof WallService.AdditionalWall) {
				nwall = { t:1,
					A:      wall.edgeA.toArray(),
					B:      wall.edgeB.toArray(),
					y:      wall.bottomY,
					h:      wall.height,
					d:      wall.depth,
					clr:    wall.material ? ("#"+wall.material.color.getHexString()) : undefined
				};
			}

			if (nwall) {
				nwall.title    = wall.title || undefined;
				nwall.ouids    = Object.keys( wall.oeuvres );

				extractComments( nwall, wall );

				_walls[ uuid ] = nwall;
			}
		}
		return _walls;
	}

	function exportAdditionalObjects(){
		var objects = window.additionalObjectsService.objects;
		var _objs = {};
		for (var uuid in objects) {
			var nobj = null, obj = objects[uuid], opts = objects[uuid].opts;
			switch( objects[uuid].type ){
				case "text":
				case "cube":
				case "plane":
					nobj = objects[uuid].opts;
					nobj.pos = obj.mesh.position.toArray();
					nobj.qua = obj.mesh.quaternion.toArray();
					nobj.zof = obj.z_offset;

					if (obj.availPlanes) {
						nobj.availPlanes = obj.availPlanes;
					}
					break;
				case "json":
					nobj = {
						json_uuid: opts.uuid,
						scale: obj.scale || 1,
						zof: obj.z_offset,
						pos: obj.mesh.position.toArray(),
						qua: obj.mesh.quaternion.toArray()
					};

					if (obj.availPlanes) {
						nobj.availPlanes = obj.availPlanes;
					}

					switch (opts.source && (nobj.source = opts.source)) {
						case "attachment":
							nobj.attachment_uid = opts.attachment_uid;
							break;
						case "url":
							nobj.source_url = opts.source_url;
							break;
					}
					break;
				case "light":
					nobj = obj.toJSON();
					break;
			}

			if (nobj) {
				extractComments( nobj, objects[uuid] );
				extractClickActs( nobj, objects[uuid] );

				nobj.title        = objects[uuid].title;
				nobj.type         = objects[uuid].type;
				nobj.template_key = nobj.template_key || objects[uuid].$template && objects[uuid].$template.$key || undefined;
				_objs[ uuid ] = nobj;
			}
		}

        for (var i in window.DragHandlesService.handles.children) {
            var v = window.DragHandlesService.handles.children[i];
            if (v.genSave) _objs[ v.uuid ] = v.genSave();
        }

		return _objs;
	}
	
	function extractComments( save, source ) {
		try {
			if (!source || !source.comments) return;

			save.comments = source.comments.toJSON() || undefined;
		} catch (error) {
			console.error( "exportArrangement.extractComments() ::", error );
		}
	}

	function extractClickActs( save, source ) {
		try {
			if (!source || !source.$clickHandler) return;

			save.clickActs = source.$clickHandler.acts;
		} catch (error) {
			console.error( "exportArrangement.extractClickActs() ::", error );
		}
	}
}

applyArrangement["v2"] = function applyArrangement_v2( arrangement, ignorePlayerOpts ){

	var wallService = window.wallService;

	var errors = [];

	if (!ignorePlayerOpts && arrangement.player != null) try {
		toPlayer( arrangement, player );
	} catch (e) { errors.push(e); }

	try {
		wallService.init( oeuvres );
	} catch (e) { errors.push(e); }

	try {
		toWalls( arrangement, wallService );
	} catch (e) { errors.push(e); }

	try {
		toAdditObjs( arrangement );
	} catch (e) { errors.push(e); }

	try {
		toSpherical360Setups( arrangement );
	} catch (e) { errors.push(e); }

	try {
		toScene( arrangement );
	} catch (e) { errors.push(e); }

	try {
		toEnvironment( arrangement );
	} catch (e) { errors.push(e); }

	/***********/
	for (let uuid in wallService.walls) try {
		wallService.walls[uuid].refresh();
		wallService.walls[uuid].refreshOeuvres();

		wallService.walls[uuid].setEdges && wallService.walls[uuid].setEdges();
	} catch (e) { errors.push(e); }


//    setTimeout(function(){
		try {
			toOeuvres( arrangement, oeuvres, wallService.walls );
		} catch (e) { errors.push(e); }

		wallService.init( oeuvres );

		//wallService.refresh();

		//wallService.clearEmpties();

		for (let uuid in wallService.walls) try {
			//wallService.walls[uuid].refresh();
			wallService.walls[uuid].refreshOeuvres();
		} catch (e) { errors.push(e); }

		if (errors.length > 0) {
			console.error( "applyArrangement_v2() :: Got errors while applying an arrangement ::", errors );

			Notification.error({
				title:   "Got errors while applying an arrangement",
				message: errors.join("\n")
			});
		}
//    });

	for (let uuid in wallService.walls) try {
		wallService.walls[uuid].refresh();
		wallService.walls[uuid].refreshOeuvres();

		wallService.walls[uuid].setEdges && wallService.walls[uuid].setEdges();
	} catch (e) { errors.push(e); }

	function toOeuvres( arrangement, oeuvres, walls ) {

		// Siistitään tilannetta ennen tietojen asettamista
		for (let uid in oeuvres) {
			oeuvres[uid].isSetted = oeuvres[uid].mesh.visible = false;

			helpers.clearOeuvreBetweenHelper( oeuvres[uid] );
		}

		// Läpikäydään teokset, mutta vain ne jotka ovat sekä tallennuksessa että nyt avoimessa testauksessa
		for (let uid in arrangement.oeuvres) {

			// Testauksessa oleva, mutta tallennuksesta puuttuva teos ohitetaan (koska ei ollut mitään tallennettua)
			if (!oeuvres[uid]) continue;

			oeuvres[uid].isSetted = true;

			oeuvres[uid].mesh.position.fromArray(   arrangement.oeuvres[uid].pos );
			oeuvres[uid].mesh.quaternion.fromArray( arrangement.oeuvres[uid].qua );
			oeuvres[uid].z_offset     = arrangement.oeuvres[uid].z_offset || 0;
			oeuvres[uid].mesh.visible = !!arrangement.oeuvres[uid].visible;
			oeuvres[uid].disableEdges = !!arrangement.oeuvres[uid].disableEdges;

			try {
				if (angular.isNumber( arrangement.oeuvres[uid].width  )) oeuvres[uid].w = arrangement.oeuvres[uid].width;
				if (angular.isNumber( arrangement.oeuvres[uid].height )) oeuvres[uid].h = arrangement.oeuvres[uid].height;
				if (angular.isNumber( arrangement.oeuvres[uid].depth  )) oeuvres[uid].d = arrangement.oeuvres[uid].depth;

				oeuvres[uid].onSizeChanged();
			} catch (e) {}

			arrangement.oeuvres[uid].availPlanes && (oeuvres[uid].availPlanes = arrangement.oeuvres[uid].availPlanes);

			oeuvres[uid].$frames = {
				canvas: new PaintingPlainFrame({
					rr       : (arrangement.oeuvres[uid].canvas || {}).rr || 0,
					d        : (arrangement.oeuvres[uid].canvas || {}).d  || 0,
					material : (arrangement.oeuvres[uid].canvas || {}).m  || { color: "#ffffff" }
				}),
				frame: new PaintingPlainFrame({
					rr       : (arrangement.oeuvres[uid].frame || {}).rr  || 0,
					d        : (arrangement.oeuvres[uid].frame || {}).d   || 0,
					material : (arrangement.oeuvres[uid].frame || {}).m   || { color: "#000000" }
				})
			}
			oeuvres[uid].$genFrames && oeuvres[uid].$genFrames();

			if (arrangement.oeuvres[uid].comments && oeuvres[uid].comments) oeuvres[uid].comments.init( arrangement.oeuvres[uid].comments );

			if (arrangement.oeuvres[uid].clickActs) new ObjectClickHandler( arrangement.oeuvres[uid].clickActs, oeuvres[uid] );

			helpers.refreshOeuvreHelper( oeuvres[uid] );
		}

		try {

			for (var wall_uuid in arrangement.walls) {

				if (walls[ wall_uuid ]) {

					for (var i in arrangement.walls[ wall_uuid ].ouids) {

						var oeuvre_uid = arrangement.walls[ wall_uuid ].ouids[ i ];

						if (oeuvres[ oeuvre_uid ] && !walls[ wall_uuid ].oeuvres[ oeuvre_uid ]) {

							console.warn( "Detected oeuvre is not on wall it supposed to be", oeuvre_uid, wall_uuid );

							walls[ wall_uuid ].oeuvres[ oeuvre_uid ] = oeuvres[ oeuvre_uid ];
							oeuvres[ oeuvre_uid ].$wall = walls[ wall_uuid ];
						}
					}
				}
			}
		} catch (error) {
			console.error( error );
		}
	}
	function toPlayer( arrangement, player ){

		player.ah = arrangement.player.ah;
		player.av = arrangement.player.av;

		player.setPos( (new Vector3()).fromArray( arrangement.player.pos ));

		player.floorObj.position.copy( player.pos );

/*		if (typeof arrangement.player.height     == "number") player.height     = player.opts.height     = arrangement.player.height;
		if (typeof arrangement.player.fov        == "number") player.fov        = player.opts.fov        = arrangement.player.fov;
		if (typeof arrangement.player.footHeight == "number") player.footHeight = player.opts.footHeight = arrangement.player.footHeight;*/
	}
	function toWalls( arrangement ){
		for (let uuid in arrangement.walls) {
			var nwall = null, wall = arrangement.walls[uuid];
			switch(wall.t){
				case 0:
					nwall = new WallService.Wall({ mesh: {
						position: new Vector3().fromArray(wall.pos),
						rotation: new Euler().setFromQuaternion(new Quaternion().fromArray(wall.qua))
					}});
					delete nwall.oeuvres["???"];

					nwall.title = wall.title;
					nwall.changeUuid( uuid );
					break;
				case 1:
					nwall = new WallService.AdditionalWall(new Vector3().fromArray(wall.A), new Vector3().fromArray(wall.B), wall.y, wall.h, wall.d );

					nwall.title = wall.title;
					nwall.changeUuid( uuid );
					wall.clr && nwall.setColor( wall.clr );
					break;
			}

			if (!nwall) continue;

			if (wall.comments && nwall.comments) nwall.comments.init( wall.comments );

			try {
				for (var i in wall.ouids) {
					if (oeuvres[ wall.ouids[i] ]) {
						// nwall.oeuvres[ wall.ouids[i] ] = oeuvres[ wall.ouids[i] ];
					}
				}
			} catch (error) {
				console.error( error );
			}

			wallService.addWall( nwall );
		}

		wallService.refresh();

		wallService.clearEmpties();

		for (let uuid in wallService.walls) {
			wallService.walls[uuid].refresh();
			wallService.walls[uuid].refreshOeuvres();

			wallService.walls[uuid].setEdges && wallService.walls[uuid].setEdges();
		}
	}
	function toScene( arrangement ){
		var data = arrangement.scene || {};
		if (data.worldLight) try {

			if (!gameService.worldLight) {
				/** @TODO */
				debugger;
			}

			let worldLightUuid = gameService.worldLight?.uuid || undefined;

			let wordlLight = AdditionalObject.Light.loadSave({
				...data.worldLight,
				uuid: worldLightUuid
			});


			if (!gameService.worldLight) {
				/** @TODO */
				debugger;
			}


		} catch (error) {}
	}

	function toEnvironment( arrangement ){
		var data = arrangement.environment || {};
			
		gameService.environment = {};

		if (data.backgroundAudio) try {

			gameService.environment.backgroundAudio = angular.copy( data.backgroundAudio );

		} catch (error) {}

		if (data.physics) try {
			if (gameService.player?.opts) {
				gameService.player.opts.disableGravity = !!data.physics.gravityDisabled;
			}

		} catch (error) {}
	}

	function toAdditObjs( arrangement ){
		var addit_objs = arrangement.addit_objs || {};

		for (var uuid in addit_objs) try {
			
			addit_objs[uuid].uuid = uuid;
			var obj = null, addit = addit_objs[ uuid ];

			if (addit.template_key) {
				if (window.additionalObjectsService.templates[ addit.template_key ]) {
					obj = window.additionalObjectsService.genFromTemplate( addit.template_key );

					if (obj) {
						addit_objs[ uuid ].pos && obj.mesh.position.fromArray(   addit_objs[ uuid ].pos );
						addit_objs[ uuid ].qua && obj.mesh.quaternion.fromArray( addit_objs[ uuid ].qua );

						addit_objs[ uuid ].zof = parseFloat(addit_objs[ uuid ].zof);
						obj.opts.z_offset = obj.z_offset = isNaN(addit_objs[ uuid ].zof)   ? 0 : addit_objs[ uuid ].zof;
					} else {
						throw "Unable to generate AdditionalObject by template '" + addit.template_key + "'";
					}
				} else {
					continue;
				}
			}

			if (!obj) switch (addit_objs[ uuid ].type) {
                case "polygon":
                    DragHandle.Polygon.loadSave( addit_objs[ uuid ]);
                    break;
				case "comment":
                    DragHandle.Comment.loadSave( addit_objs[ uuid ]);
                    break;
				case "meter":
                    DragHandle.Meter.loadSave( addit_objs[ uuid ]);
                    break;
				case "plane":
					window.AdditionalObject.Plane.loadSave( addit_objs[ uuid ]);
					break;
				case "text":
					window.AdditionalObject.Text.loadSave( addit_objs[ uuid ]);
					break;
				case "cube":
					obj = window.additionalObjectsService.generateCube( addit_objs[ uuid ]);

					addit.pos && obj.mesh.position.fromArray(   addit.pos );
					addit.qua && obj.mesh.quaternion.fromArray( addit.qua );

					addit.zof = parseFloat( addit.zof );
					obj.opts.z_offset = obj.z_offset = isNaN( addit ) ? 0 : addit.zof;
					break;
				case "json":
					if (addit.source == "attachment") {
						if (addit.attachment_uid.match( /^A7[A-F0-9]{14}$/ )) {

							obj = window.additionalObjectsService.generateFromAttachmentJson( addit );

						} else errors.push("could not load additional object as attachment. Attachment UID not found!");

					} else if (addit.source == "url") {
						if (typeof addit.source_url == "string") {

							obj = window.additionalObjectsService.generateFromUrl( addit );

						} else errors.push("Not Implemented! Missing url");

					} else errors.push("Not Implemented! Could only load additional objects as attachments or from url");
					break;
				case "light":
					window.AdditionalObject.Light.loadSave( addit_objs[ uuid ]);
					break;
			}

			if (obj) {

				addit.pos && Array.isArray( addit.pos ) && obj.mesh.position.fromArray(   addit.pos );
				addit.qua && Array.isArray( addit.qua ) && obj.mesh.quaternion.fromArray( addit.qua );

				addit.zof = parseFloat( addit.zof );
				obj.opts.z_offset = obj.z_offset = isNaN( addit.zof ) ? 0 : addit.zof;

				if (typeof addit.scale == "number") {
					obj.opts.scale = obj.scale = addit.scale;
				}

				if (addit_objs[ uuid ].template_key) {
					if (window.additionalObjectsService.templates[ addit_objs[ uuid ].template_key ]) {
						if (obj.$setTemplate( window.additionalObjectsService.templates[ addit_objs[ uuid ].template_key ] ));
					} else console.warn( "Could not found additionalObject template '"+ addit_objs[ uuid ].template_key +"' from templates!" );
				}

				obj.title = obj.title || addit_objs[ uuid ].title;

				addit_objs[ uuid ].availPlanes && ( obj.availPlanes = addit_objs[ uuid ].availPlanes );

				if (addit_objs[ uuid ].comments) obj.comments.init( addit_objs[ uuid ].comments );
				
				if (addit_objs[ uuid ].clickActs) try {
					new ObjectClickHandler( addit_objs[ uuid ].clickActs, obj );
				} catch (error) { console.error( error ); }
			}
		} catch (error) {
			errors.push( error );
		}
	}

	function toSpherical360Setups( arrangement ) {

		window.spherical360SetupService.loadSaves( arrangement.spherical360Setups );

	}
}


function Arrangement( opts, model ){
	opts = opts || {};

	this.uid     = opts.uid || null;

	this.version = opts.version || 2;
	this.oeuvres = opts.oeuvres || [];
	this.data    = opts.data    || {};
	this.$model  = model = opts.$model || model;

	this.preview_model_uid = opts.preview_model_uid || model && model.uid;

	if( this.uid == null && this.$access == null ) this.$access = 2;
}
Arrangement.prototype.isSaved = function( ){
	return this.uid && Arrangement.uid_regexp.test( this.uid );
}
Arrangement.uid_regexp = /^A5[A-f0-9]{14}$/;
Arrangement.isArrangement = function( val ){
	return val instanceof Arrangement || Arrangement.uid_regexp.test( val.uid );
}
export {
	saveLocally,
	getSaves,
	applyArrangement,
	exportArrangement,
	Arrangement
};
